<template>
    <div id="create_account">
        <div class="header" :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}">
            <img :src="`/img/logo/${info.companyId}.png`" class="logo_company" alt="Logo">
            <img src="../../../public/img/brad.png" alt="" class="brad_icon">
        </div>
        <div class="content">
            <div class="user_info">
                <user-info v-if="isDone"></user-info>
            </div>
            <div class="chat" :style="{background: `linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 0%, ${colors.second} 500%)`}">
                <div class="chat_content">
                    <div v-for="(message,i) of messages" :class="[message.author == 'output' ? 'sistem_messages' : 'user_messages']" :key="i">
                        <span 
                        :style="[message.author == 'output' ? {color: colors.fifth} : {backgroundColor: colors.fifth}]"
                        :class="[message.author == 'output' ? 'sistem_message' : 'user_message']">
                            {{message.message}}
                        </span>
                    </div>
                    <typing-loader v-show="showLoader"></typing-loader>
                </div>
                <div class="input_message" 
                v-show="false"
                    v-if="
                        inputOptions.type !== 'period' && 
                        inputOptions.type !== 'proficiency' && 
                        inputOptions.type !== 'worktimeAvailability'&& 
                        inputOptions.type !== 'enrollmentCity' && 
                        inputOptions.type !== 'knowAboutJobOpening' && 
                        inputOptions.type !== 'emailConfirmation' && 
                        inputOptions.type !== 'graduation.type'">
                    <input v-if="!inputOptions.isMasked" ref="input" :type="inputOptions.type" :placeholder="inputOptions.placeholder" v-model="userMessage" 
                    :disabled="disabled == 1 ? true : false"
                    @keyup.enter="sendMessage()">
                    <the-mask v-if="inputOptions.isMasked" :mask="inputOptions.inputModel" :placeholder="inputOptions.placeholder" 
                    ref="input"
                    v-model="userMessage" 
                    :disabled="disabled == 1 ? true : false"/>
                    <button class="send_message_group" @click="sendMessage()" :disabled="disabled == 1 ? true : false">
                        <img src="../../../public/img/icons/send-message-icon.png" alt="">
                    </button>
                </div>

                <div class="input_message" v-if="inputOptions.type == 'proficiency'">
                    <select v-model="selected" @change="onSelectedProficiency($event)">
                        <option disabled selected>{{selected}}</option>
                        <option :value="index" v-for="(inputButtonOption, index) of inputButtonOptions" :key="inputButtonOption">{{inputButtonOption}}</option>
                    </select>
                </div>
                <div class="input_message" v-if="inputOptions.type == 'worktimeAvailability'">
                    <select v-model="selected" @change="onSelected($event)">
                        <option disabled selected>{{selected}}</option>
                        <option :value="inputButtonOption" v-for="inputButtonOption of inputButtonOptions" :key="inputButtonOption">{{inputButtonOption}}</option>
                    </select>
                </div>
                <div class="input_message" v-if="inputOptions.type == 'graduation.type'">
                    <select v-model="selected" @change="onSelected($event)">
                        <option disabled selected>{{selected}}</option>
                        <option :value="inputButtonOption" v-for="inputButtonOption of inputButtonOptions" :key="inputButtonOption">{{inputButtonOption}}</option>
                    </select>
                </div>
                <div class="input_message" v-if="inputOptions.type == 'enrollmentCity'">
                    <select v-model="selected" @change="onSelectedEnrollmentCity($event)">
                        <option disabled selected>{{selected}}</option>
                        <option :value="index" v-for="(inputButtonOption, index) of inputButtonOptions" :key="inputButtonOption">{{inputButtonOption}}</option>
                    </select>
                </div>
                <div class="input_message borderless" v-if="inputOptions.type == 'knowAboutJobOpening' || inputOptions.type == 'emailConfirmation'">
                    <button 
                        @click="onSelectBooleanOption(true)"
                        class="btn rounded" 
                        :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}">Sim</button>
                    <button 
                        @click="onSelectBooleanOption(false)"
                        class="btn rounded" 
                        :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}">Não</button>
                </div>
            </div>
        </div>
        <modal v-if="modal.show" @close="modal.show = false">
            <h3 slot="header">{{modal.title}}</h3>
            <h3 slot="body">{{modal.message}}</h3>
        </modal>
    </div>
</template>

<script>
import userInfo from '../../components/userInfo/userInfo'
import TypingLoader from '../../components/Loaders/TypingLoader'
import Modal from '../../components/modals/Modal'
import {TheMask} from 'vue-the-mask'
import firebase from "firebase";
import { promises } from 'fs'
// import { Bus } from '../../event-bus.js';

export default {
    components:{
        'user-info': userInfo,
        'typing-loader': TypingLoader,
        TheMask,
        modal: Modal
    },
    data: () =>({
        colors: '',
        disabled: 1,
        isDone: false,
        showLoader: true,
        inputMasked:'',
        inputOptions:{
            isMasked: false,
            inputModel: '',
            placeholder:  'Digite aqui sua mensagem',
            type: 'text'
        },
        selected: 'Selecione uma opção',
        inputButtonOptions: {},
        modal:{
            show: false,
            title: '',
            message: ''
        },
        info: '',
        enrollment:{
            id: ''
        },
        flowMessage:[],
        userMessage: '',
        userMessageTranslated: '',
        questionType: '',
        messages:[],
        invalidPassword: false,
        aditionalFlow:{
            wrongPassword: 'Hmm, você já tem cadastro conosco, mas aparentemente não lembra sua senha, certo? \n Que tal tentar novamente?',
            attempts: 0,
            resetPassword: 'Enviamos um link no seu e-mail, para você redefinir sua senha, ok?'
        },
        enrollmentClosedFlow: 'Olá!, infelizmente as incrições para o programa de estágio cash manager do Bradesco se encerraram 😔'
    }),

    async created(){
        this.colors = this.$store.getters.getCustomColors
        this.info = this.$store.getters.getEssentialInfo
        this.messages.push({
            author: 'output',
            message: this.enrollmentClosedFlow
        })
        this.disabled = true
        this.showLoader = false
        // this.enrollment = JSON.parse(localStorage.getItem('enrollment'))
        // if(!this.enrollment) this.enrollment = {id: ''} 
        
        // console.log('Log: ', this.enrollment)

    },

    async mounted(){
        // await this.getOrCreateEnrollment(this.enrollment.id)
        // await this.getNextMessage(this.enrollment.id)
        // await this.setFocus()
    },
    

    methods:{
        async setFocus(){
            let input = document.querySelector('.input_message input')
            if(input) input.focus()
            // this.$refs.input.focus();
        },
        enableInput(isTyping){
            this.disabled = !isTyping
            this.showLoader = !isTyping
            // this.$refs.input.focus()
        },

        scrollToBottom(){
            let chatMessagesContent = document.querySelector('.chat_content');
            let chatMessagesContentHeight = document.querySelector('.chat_content').scrollHeight;
            setTimeout(() => {
                chatMessagesContent.scrollTo(0, chatMessagesContent.scrollHeight)
            }, 200)
        },

        async onSelectedWorktimeAvailability(event){
            this.userMessage = Number(event.target.value)
            await this.sendMessage()
            this.userMessage = null
            this.selected = "Selecione uma opção"
        },

        async onSelectedProficiency(event){
            let selectedValue = event.target.value
            if(selectedValue == 0) {
                this.userMessage = 'basic'
                this.userMessageTranslated = 'Básico'
            }
            if(selectedValue == 1) {
                this.userMessage = 'intermediate'
                this.userMessageTranslated = 'Intermediário'
            }
            if(selectedValue == 2) {
                this.userMessage = 'advanced'
                this.userMessageTranslated = 'Avançado'
            }
            if(selectedValue == 3) {
                this.userMessage = 'fluent'
                this.userMessageTranslated = 'Fluente'
            }
            await this.sendMessage()
            selectedValue = null
            this.selected = "Selecione uma opção"
        },

        async onSelectBooleanOption(opt){
            if(opt){
                this.userMessage = true
            }else{
                this.userMessage = false
            }
            this.inputOptions.type = ''
            await this.sendMessage()
        },

        async onSelected(){
            this.userMessage = event.target.value
            await this.sendMessage()
            this.userMessage = null
            this.selected = "Selecione uma opção"
        },
        
        async onSelectedEnrollmentCity(){
            let selectedValue = event.target.value
            // "belo horizonte","brasilia","campinas","curitiba","goiania","joinville","porto alegre","rio de janeiro","sao paulo","salvador","fortaleza"
            if(selectedValue == 0) {
                this.userMessage = 'belo horizonte'
                this.userMessageTranslated = 'Belo Horizonte'
            }
            if(selectedValue == 1) {
                this.userMessage = 'brasilia'
                this.userMessageTranslated = 'Brasilia'
            }
            if(selectedValue == 2) {
                this.userMessage = 'campinas'
                this.userMessageTranslated = 'Campinas'
            }
            if(selectedValue == 3) {
                this.userMessage = 'curitiba'
                this.userMessageTranslated = 'Curitiba'
            }
            if(selectedValue == 4) {
                this.userMessage = 'goiania'
                this.userMessageTranslated = 'Goiânia'
            }
            if(selectedValue == 5) {
                this.userMessage = 'joinville'
                this.userMessageTranslated = 'Joinville'
            }
            if(selectedValue == 6) {
                this.userMessage = 'porto alegre'
                this.userMessageTranslated = 'Porto Alegre'
            }
            if(selectedValue == 7) {
                this.userMessage = 'rio de janeiro'
                this.userMessageTranslated = 'Rio de Janeiro'
            }
            if(selectedValue == 8) {
                this.userMessage = 'sao paulo'
                this.userMessageTranslated = 'São Paulo'
            }
            if(selectedValue == 9) {
                this.userMessage = 'salvador'
                this.userMessageTranslated = 'Salvador'
            }
            if(selectedValue == 10) {
                this.userMessage = 'fortaleza'
                this.userMessageTranslated = 'Fortaleza'
            }
            if(selectedValue == 11) {
                this.userMessage = 'piracicaba'
                this.userMessageTranslated = 'Piracicaba'
            }
            if(selectedValue == 12) {
                this.userMessage = 'osasco'
                this.userMessageTranslated = 'Osasco'
            }
            if(selectedValue == 13) {
                this.userMessage = 'recife'
                this.userMessageTranslated = 'Recife'
            }
            await this.sendMessage()
            selectedValue = null
            this.selected = "Selecione uma opção"
        },

        async changeInputTypeByValue(value){
            switch (value) {
                case 'knowAboutJobOpening':
                    this.inputOptions.type = 'knowAboutJobOpening'
                    break;
                case 'emailConfirmation':
                    this.inputOptions.type = 'emailConfirmation'
                    break;
                case 'name':
                    this.inputOptions.placeholder = 'Digite aqui seu nome'
                    this.inputOptions.type = 'text'
                    break;

                case 'cpf':
                    this.inputOptions.placeholder = 'Digite aqui seu cpf'
                    this.inputOptions.type = 'text'
                    this.inputOptions.isMasked = true
                    this.inputOptions.inputModel = '###.###.###-##'
                    document.addEventListener('keyup', (e) => {
                        if(e.keyCode == 13 && this.questionType == 'cpf') this.sendMessage()
                    })
                    break;

                case 'age':
                    this.inputOptions.placeholder = 'Digite aqui sua idade'
                    this.inputOptions.type = 'number'
                    this.inputOptions.isMasked = false
                    break;

                case 'email':
                    this.inputOptions.placeholder = 'Digite aqui seu e-mail'
                    this.inputOptions.type = 'email'
                    break;

                case 'phone':
                    this.inputOptions.placeholder = 'Digite aqui seu telefone'
                    this.inputOptions.type = 'text'
                    this.inputOptions.isMasked = true
                    this.inputOptions.inputModel = `(##) #####-####`
                    document.addEventListener('keyup', (e) => {
                        if(e.keyCode == 13 && this.questionType == 'phone') this.sendMessage()
                    })
                    break;

                case 'address.cep':
                    this.inputOptions.placeholder = 'Digite aqui seu cep'
                    this.inputOptions.type = 'text'
                    this.inputOptions.inputModel = `#####-###`
                    this.inputOptions.isMasked = true
                    document.addEventListener('keyup', (e) => {
                        if(e.keyCode == 13 && this.questionType == 'address.cep') this.sendMessage()
                    })
                    break;

                case 'graduation.conclusion':
                    this.inputOptions.placeholder = 'ex: 2019-08'
                    this.inputOptions.type = 'month'
                    this.inputOptions.isMasked = false
                    break;

                case 'graduation.course':
                    this.inputOptions.placeholder = 'Digite aqui seu curso'
                    this.inputOptions.type = 'text'
                    break;

                case 'graduation.university':
                    this.inputOptions.placeholder = 'Digite aqui sua universidade'
                    this.inputOptions.type = 'text'
                    break;

                case 'graduation.startLesson' || 'graduation.endLesson':
                    this.inputOptions.type = 'time'
                    break;

                case 'worktimeAvailability':
                    this.inputButtonOptions = ['4', '6']
                    this.inputOptions.type = 'worktimeAvailability'
                    break;

                case 'graduation.type':
                    this.inputButtonOptions = ['Técnologo', 'Superior']
                    this.inputOptions.type = 'graduation.type'
                    break;

                case 'language.english':
                    this.inputButtonOptions = ['Básico', 'Intermediário', 'Avançado', 'Fluente']
                    this.inputOptions.type = 'proficiency'
                    break;
                case 'enrollmentCity':
                    this.inputButtonOptions = ["Belo Horizonte","Brasília","Campinas","Curitiba","Goiania","Joinville","Porto Alegre","Rio de Janeiro","São Paulo","Salvador","Fortaleza", "Piracicaba", "Osasco", "Recife"]
                    this.inputOptions.type = 'enrollmentCity'
                    break;
                case 'password':
                    this.inputOptions.placeholder = 'Digite aqui sua senha'
                    this.inputOptions.type = 'password'
                    break;
            
                default:
                    this.inputOptions.placeholder = ''
                    break;
            }    
        },

        async sendMessage(){
            if(this.userMessage.length == 0){
                this.modal.title = 'Digite sua mensagem!'
                this.modal.message = 'Todos os campos são obrigatórios'
                this.modal.show = true
                return
            }
            let body = {}
            body[this.questionType] = this.userMessage
            if(this.questionType == 'language.english' || this.questionType == 'enrollmentCity'){
                this.messages.push({
                    author: 'user',
                    message: this.userMessageTranslated
                })

            }
            console.log('Message Sended: ', this.messages)
            localStorage.setItem('enrollment', JSON.stringify(Object.assign(this.enrollment, body)))
            this.enrollment = JSON.parse(localStorage.getItem('enrollment'))
            if(this.questionType != 'password' && 
                this.questionType != 'language.english' && 
                this.questionType != 'enrollmentCity' && 
                this.questionType != 'emailConfirmation' && 
                this.questionType != 'knowAboutJobOpening'){
                this.messages.push({
                    author: 'user',
                    message: this.userMessage
                })
            }
            this.scrollToBottom()
            var currentMessage = this.userMessage
            this.userMessage = ""
            // if(this.questionType == 'email'){
            //     try {
            //         const emailVerifier = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_AUTH}/users/?email=${currentMessage}`)
            //         console.log('emailVerifier: ', emailVerifier.body)
            //         if(emailVerifier.body.id){
            //             await this.authUser({id: emailVerifier.body.id})
            //             localStorage.setItem('authUserId',emailVerifier.body.id)
            //         } 
            //     } catch (error) {
            //         if(error.body.response == 'user(s) not found') {
            //             let body = {"email":currentMessage}
            //             this.getNextMessage(this.enrollment.id, body)
                        
            //             console.log('User not found, will be create a new after')
            //         }
            //         console.error('Error on email Verifier: ', error)
            //         return
            //     }
            // }
            if(this.questionType == 'password') {
                if(currentMessage.length < 6) {
                    this.messages.push({
                        author: 'output',
                        message: 'oops... para sua segurança, escolha uma senha com, no mínimo, 6 caracteres'
                    })
                    return
                }
            }
            if(!this.invalidPassword) this.getNextMessage(this.enrollment.id, body)
            
        },

        async getOrCreateEnrollment(enrollmentId){
            this.enableInput(true)
            try {
                let enrollmentReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_CHATBOT}/enrollments/${enrollmentId}`)
                console.log('enrollmentReq: ', enrollmentReq.body)
                this.enrollment = enrollmentReq.body
                localStorage.setItem('enrollment', JSON.stringify(this.enrollment))
                this.filterHistory(this.enrollment.__context.history)

            } catch (error) {
                console.error('Erro ao criar/pegar inscrição: ', error.body.error);
            }
            this.enableInput(false)
        },

        async getNextMessage(enrollmentId, body){
            do {
                try {
                    let enrollmentReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_CHATBOT}/enrollments/${enrollmentId}/flow/next`, body)
                    console.log('enrollmentReq: ', enrollmentReq.body)
                    this.flowMessage = enrollmentReq.body

                    if(this.flowMessage.type == 'done') {
                        const localEnrollment = JSON.parse(localStorage.getItem('enrollment'))
                        const userInfos = {
                            id: this.enrollment.id,
                            email: this.enrollment.email
                        }
                        if(!localStorage.getItem('authUserId')){
                            const authReqBody = {
                                "name": localEnrollment.name,
                                "email": localEnrollment.email,
                                "password": localEnrollment.password,
                                "newUser": true
                            }
                            // this.authUser(authReqBody)
                        }
                        localStorage.setItem('userInfo', JSON.stringify(userInfos))  
                        this.enableInput(false)
                        console.log('Redirecionando...')
                            setTimeout(() => {
                                this.$router.push('/user-info')
                            }, 3000);
                        return
                    }

                    this.enableInput(true)
                    this.flowMessage = enrollmentReq.body
                    this.questionType = enrollmentReq.body.data ? enrollmentReq.body.data.field : ''
                    this.questionType = this.flowMessage.data.field || ''
                    await this.changeInputTypeByValue(this.questionType)
                    console.log('Refs: ', this.$refs.input)
                    console.log('Question Type: ', this.questionType)  
     
                    let chatMessages = []
                    this.enableInput(true)
                    if(this.flowMessage.type === 'text'){
                        const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                        chatMessages = this.flowMessage.data
                        await delay(2000)
                    }
                    this.enableInput(false)
                    
                    if(this.flowMessage.type === 'question'){
                        chatMessages = this.flowMessage.data.text
                        this.enableInput(true)
                    }
                    if(this.flowMessage.type !== 'integration'){
                        this.messages.push({
                            author: 'output',
                            message: chatMessages
                        })
                    }
                    this.scrollToBottom()
                    this.setFocus()
    
                } catch (error) {
                    console.error('Erro ao seguir o fluxo: ', error);
                    
                }        
            } while (this.flowMessage.type != 'question');


        },

        async createNewCandidate(){
            await this.getOrCreateEnrollment(this.enrollment.id)
            const body = this.enrollment
            let splittedName = this.enrollment.name.split(" ")


            if(splittedName.constructor == [].constructor){
                body.firstName = splittedName[0]
                body.lastName = ''
                for(let i = 1; i <= splittedName.length - 1; i++){ 
                    body.lastName += splittedName[i] + " "
                } 
            }
            if(splittedName.constructor !== [].constructor){
                body.firstName = splittedName
                body.lastName = undefined
            }
            delete body.name
            console.log('Body Create candidate: ', body)

            try {
                let createNewCandidateReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_CHATBOT}/candidates`,body)
                console.log('createNewCandidateReq: ', createNewCandidateReq)
            } catch (error) {
                console.error('Erro ao criar candidato: ', error)
            }
        },

        sendPasswordResetEmail(userEmail){
            var auth = firebase.auth();

            auth.sendPasswordResetEmail(userEmail).then(function() {
                console.log('Password reset sended')
            }).catch(function(error) {
                console.error('Shit happens: ', error)
            });
        },

        async authUser(body){
            this.enableInput(false)
            try {
                const authUserReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_AUTH}/users`, body)
                console.log('authUserRes: ', authUserReq.body)
                this.invalidPassword = false //Leo: Vand, coloquei isso, pois prevejo que precisará quando a pessoa errar a senha a primeira vez, mas acertar na segunda. Sinta-se a vontade em tirar caso minha previsão esteja errada
            } catch (error) {
                if(error.body.response == 'invalid email and/or password'){
                    this.invalidPassword = true
                    this.sendAdditionalFlow()
                }
                console.error('Error in auth user: ', error.body)
            }   
            // await this.setFocus()
            this.enableInput(true)
        },

        filterHistory(historyFlow){
            var beforePropName = ""

            historyFlow.forEach((historyNode, index) => {
                if(index > 0) {
                    beforePropName = historyFlow[index - 1].data
                    if(beforePropName.data) beforePropName = beforePropName.data.field
                }
                if(historyNode.data.data){
                    if(historyNode.data.type === 'text'){
                        this.messages.push({
                            author: historyNode.type,
                            message: historyNode.data.data
                        })
                    }
                    if(historyNode.data.type === 'question'){
                        if(historyFlow[index].node != historyFlow[index - 1].node ){
                            this.messages.push({
                                author: historyNode.type,
                                message: historyNode.data.data.text
                            })
                        }
                    }
                } 
                
                if(historyNode.data[beforePropName] && historyNode.type == 'input' && historyNode.data){
                    this.messages.push({
                        author: historyNode.type,
                        message:  historyNode.data[beforePropName]
                    })
                }
                
                this.scrollToBottom()
            });
        },

        sendAdditionalFlow(){
            if(this.aditionalFlow.attempts < 1){
                this.messages.push({
                    author: 'output',
                    message: this.aditionalFlow.wrongPassword
                })
                this.scrollToBottom()
                this.aditionalFlow.attempts ++
                return
            }
            this.messages.push({
                author: 'output',
                message: this.aditionalFlow.resetPassword
            })
            this.setFocus()
            this.sendPasswordResetEmail(this.enrollment.email)
            this.scrollToBottom()
            console.log('Send password change email')
        }
    }
}
</script>

<style lang="scss">
#create_account{
    height: 100vh;

    .header{
        height: 7vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 15px;

        .logo_company{
            max-width: 120px;
            margin-bottom: 10px;
        }

        .brad_icon{
            max-width: 90px;
            position: relative;
            top: 50px;
            right: 33%;
        }
    }

    .content{
        height: calc(93% - 10px);
        display: flex;

        .user_info{
            width: 33.33%;
            // height: calc(90% - 10px);
        }

        .chat{
            width: 33.33%;
            display: flex;
            flex-direction: column;
            // max-width: 500px;
            // margin: 0 auto;
            // height: calc(90% - 10px);

            .chat_content{
                display: block;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                padding: 15px;
                overflow: scroll;
                -webkit-overflow-scrolling: touch;
                height: 80%;

                .sistem_messages{
                    margin: 5px 0;
                    width: 100%;
                    display: flex;
                    line-height: 25px;

                    .sistem_message{
                        display: flex;
                        border: 1px solid #8c8c8c;
                        padding: 15px;
                        border-radius: 15px;
                        background-color: transparent; 
                        color: blue;
                        font-weight: 700;
                    }
                }
                .user_messages{
                    margin: 5px 0;
                    display: flex;
                    justify-content: flex-end;
                    width: 100%;
                    line-height: 25px;

                    .user_message{
                        display: flex;
                        padding: 15px;
                        border-radius: 15px;
                        background-color: blue;
                        color: #fff;
                        font-weight: 700;

                        &:nth-child(1){
                            margin: 10px 0 0 0;
                        }
                    }
                }
            }
            .input_message.borderless{
                border: none;
            }
            .input_message{
                height: 10%;
                max-height: 55px;
                display: flex;
                justify-content: space-between;
                border: 1px solid #ccc;
                border-radius: 50px;
                margin: auto 20px;

                input{
                    border: none;
                    background: transparent;
                    width: 100%;
                    // padding: 20px 10px 10px 10px;
                    padding: 10px;
                    resize: none;

                    &:disabled{
                        opacity: .2;
                    }
        
                }
                select{
                    width: 100%;
                    background: transparent;
                    border: none;
                }
                .send_message_group{
                    background-color: #7C7C7C;
                    border-radius: 150px;
                    margin: 10px;
                    width: auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: none;

                    &:disabled{
                        opacity: .2;
                    }

                    img{
                        width: 40%;
                        padding: 20%;
                    }
                }

                .btn.rounded{
                    width: auto;

                    &:hover{
                        cursor: pointer;
                    }
                }
            }
        }
    }   
    @media screen and (max-width: 992px) { 
        .header{
            .brad_icon{
                right: 0%;
            }
        }
        .content{
                justify-content: center;
            .user_info{
                display: none;
            }
            .chat{
                width: 100%;
            }
        }
    }
}
</style>
